import React, { useState } from 'react'
import PolaroidModal from '../../../../components/polaroid-modal/polaroid-modal'

import imageFront from '../../../../assets/images/optimized/r-front-wide.webp'
import imageGarden from '../../../../assets/images/optimized/r-common-garden.webp'
import imageEntreGarden from '../../../../assets/images/optimized/r-entre-garden-2.webp'
import imageEntreGate from '../../../../assets/images/optimized/r-entre-gate.webp'

import './showcase-hotel.css'

const images = [
  { src: imageFront, alt: "Ringarens Lägenhetshotell" },
  { src: imageGarden, alt: "Vår lummiga innergård" },
  { src: imageEntreGarden, alt: "Privat innergård och säker förvaring av cyklar" },
  { src: imageEntreGate, alt: "Kodad entréport för säker tillgång" },
];


const ShowcaseHotel = () => {
  const [currentImage, setCurrentImage] = useState(null);

  const handleImageClick = (image) => {
    setCurrentImage(image);
  };

  const handleClose = () => {
    setCurrentImage(null);
  };

  return (
    <section className="home__hotel">
      <h2>Hotellet</h2>
      <p>
        På Ringarens Lägenhetshotell erbjuder vi ett utmärkt utbud av lägenheter för uthyrning. Varje lägenhet är smakfullt inredd och utrustad med allt du behöver för en bekväm och minnesvärd vistelse. Vare sig du är här för en romantisk helg, en familjesemester eller en affärsresa, erbjuder vi ett boende som passar dina behov.
      </p>
      <p>
        Vårt centralt belägna lägenhetshotell ger dig möjlighet att uppleva Gotlands naturskönhet och Visbys rika historia direkt utanför din dörr. Och inomhus, är ditt välbefinnande och komfort alltid vår högsta prioritet.
      </p>
      <div className="showcase-hotel">
        {images.map((image, index) => (
          <button
            aria-label={`View ${image.alt}`}
            className="showcase-hotel__polaroid"
            onClick={() => handleImageClick(image)}
            key={index}
            style={{ transform: `rotate(${image.tilt}deg)` }}
          >
            <div className="showcase-hotel__image">
              <img src={image.src} alt={image.alt} />
            </div>
            <div className="showcase-hotel__caption">{image.alt}</div>
          </button>
        ))}
      </div>

      <PolaroidModal
        open={currentImage !== null}
        onClose={handleClose}
        image={currentImage?.src}
        caption={currentImage?.alt}
      />
    </section>
  )
}

export default ShowcaseHotel
